import { trackClickContinueShopping } from '@libs/analytics';
import {
    Button,
    Drawer,
    Heading,
    Icon,
    TextPassage,
} from '@petsmart-ui/sparky';
import { ResponsivePicture } from '@libs/shared-ui';

import { decodeEntityString } from '@libs/algolia';
import { NAVIGATION_URLS } from '@libs/core';
import type { AddedToCartDrawerProps } from './types';

import './AddedToCartDrawer.scss';

const IMG_SIZE_BASKET_PRODUCT = {
    width: 80,
    height: 80,
};

export default function AddedToCartDrawer({
    basketItems,
    onClose,
}: Readonly<AddedToCartDrawerProps>) {
    return (
        <Drawer
            align="right"
            className="added-to-cart-drawer"
            data-testid="added-to-cart-drawer"
            isActive={basketItems.length > 0}
            onClose={onClose}
            dismissible
        >
            <Drawer.Header>
                <Icon name="check-circle-fill" />
                <Heading tagName="h2">Added to cart</Heading>
            </Drawer.Header>
            <Drawer.Body>
                <ul className="basket-item-list">
                    {basketItems.map(item => (
                        <li className="basket-item" key={item.product_id}>
                            {item?.c_productImages?.small && (
                                <ResponsivePicture
                                    src={item.c_productImages.small}
                                    alt={`${item.product_name} image`}
                                    size={IMG_SIZE_BASKET_PRODUCT}
                                />
                            )}
                            <TextPassage>
                                {decodeEntityString(item.product_name)}
                            </TextPassage>
                        </li>
                    ))}
                </ul>
            </Drawer.Body>
            <Drawer.Footer>
                <Button
                    type="button"
                    variant="primary"
                    text="View cart and checkout"
                    href={NAVIGATION_URLS.legacy.cart}
                    fullWidth
                />
                <Button
                    type="button"
                    onClick={() => {
                        trackClickContinueShopping();
                        onClose();
                    }}
                    text="Continue shopping"
                    fullWidth
                />
            </Drawer.Footer>
        </Drawer>
    );
}
